import React from 'react';

const MatchingAnswersIcon = () => {
    return (
        <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.666016 8.25C0.666016 3.83172 4.24774 0.25 8.66602 0.25H24.666C29.0843 0.25 32.666 3.83172 32.666 8.25V23.75C32.666 28.1683 29.0843 31.75 24.666 31.75H8.66602C4.24774 31.75 0.666016 28.1683 0.666016 23.75V8.25Z" fill="#E6F7F8" />
            <path d="M9.16602 16.75L13.666 21.25L24.166 10.75" stroke="url(#paint0_linear_3690_29828)"
                strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            <defs>
                <linearGradient id="paint0_linear_3690_29828" x1="8.11282" y1="10.75" x2="24.6779" y2="11.532" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#32A6AE" />
                    <stop offset="1" stopColor="#00BBA7" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default MatchingAnswersIcon;